export const ged = {
  errorUploadingDocument: "Error uploading the document",
  uploder: "Upload a document",
  title: "Title",
  auteur: "Author",
  tags: "Tags",
  dossier: "Folder",
  choisierDos: "Choose a folder",
  version: "Version",
  fichier: "File",
  uploderr: "Upload",
  selectFile: "Please select a file",
  impossibleToGetDetails: "Unable to fetch details",
  impossibleToGetVersions: "Unable to fetch versions",
  updateVersion: "Update Version",
  consult: "View",
  versions: "All versions",
  updateVers: "Update version",
  details: "Document details",
  versionCourante: "Current version",
  createdAt: "Created at",
  updatedAt: "Updated at",
  voir: "View file",
  telecharger: "Download",
  close: "Close",
  versionss: "Document versions",
  aucun: "No version available",
  nomObligatoire: "Name is required",
  retour: "Back",
  resutatDos: "Folder results",
  resultatDoc: "Document results",
  contenu: "Folder content",
  nouveauDos: "New folder",
  nouveauDoc: "New document",
  sousDos: "Subfolders",
  doc: "Documents",
  nomDos: "Folder name",
  creer: "Create",
  gestion: "Folder and Document Management",
  recherche: "Search..",
  racin: "Root folders",
  option: "Parent folder (optional)",
  rac: "Root",
};
